import { createApi } from '@reduxjs/toolkit/query/react'
import { API_ENDPOINTS } from 'Constants'
import { IEndorsCommonProposal, IEndorsCommonProposalDetails, IFinanceDetails, IFinancialHealthEndorsement, IPlanDetailsHealth, IPlanInformationHealth} from 'Pages/Customer360/types'
import { healthUrlQuery } from 'Services/baseQuery'

export const surakshaCustomer360Api = createApi({
  reducerPath: 'suraksha360',
  baseQuery: healthUrlQuery,
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    getHealthPolicyInformation: builder.query<IPlanInformationHealth, IPlanDetailsHealth>({
      query: (filters) => ({
        url: `${API_ENDPOINTS.BOB.GET_HEALTH_POLICY_INFORMATION}`,
        method: 'GET',
        params: filters,
        rawResponse: true,
      }),
    }),

    getHealthEndorsFinancial: builder.query<IFinancialHealthEndorsement,IFinanceDetails>({
      query: (filters) => ({
        url: `${API_ENDPOINTS.BOB.GET_HEALTH_ENDORSE_FINANCIAL}`,
        method: 'GET',
        params: filters,
        rawResponse: true,
      }),
    }),

    getEndorsCommonProposalDetails: builder.query<IEndorsCommonProposal,IEndorsCommonProposalDetails>({
      query: (filters) => ({
        url: `${API_ENDPOINTS.BOB.GET_ENDORSE_COMMON_PROPOSAL_DETAILS}`,
        method: 'GET',
        params: filters,
        rawResponse: true,
      }),
    }),

  }),
})

export const { 
  useLazyGetHealthPolicyInformationQuery, 
  useGetHealthEndorsFinancialQuery, 
  useLazyGetHealthEndorsFinancialQuery,
  useGetEndorsCommonProposalDetailsQuery,
} = surakshaCustomer360Api


